import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getSubstituteSkuList } from "../../../../services/sku";
import ProductCard from "../../../ProductListing/ProductsGrid/ProductCard/ProductCard";

import Ripple from "../../../ui/spinners/ripple/Ripple";
import CardsModal from "../CardsModal";

const AlternativesModal = ({ close, skuId }) => {
  const selectedMechanic = useSelector((state) => state.mechanic);
  const [substituteSkus, setSubstituteSkus] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 4;

  useEffect(() => {
    const fetchSubstituteSkuList = async () => {
      setIsLoading(true);
      try {
        const { data } = await getSubstituteSkuList(
          skuId,
          selectedMechanic?.id
        );
        setSubstituteSkus(data.skuList || []);
      } catch (error) {
        console.error(error);
      }
      setIsLoading(false);
    };

    if (skuId && selectedMechanic?.id) {
      fetchSubstituteSkuList();
    }
  }, [skuId, selectedMechanic?.id]);

  const totalPages = Math.ceil(substituteSkus.length / itemsPerPage);
  const startIndex = currentPage * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentSkus = substituteSkus.slice(startIndex, endIndex);

  const goToNextPage = () => {
    if (currentPage < totalPages - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  const goToPreviousPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <CardsModal
      close={close}
      classNames="!w-[70vw] !max-w-[80vw] !max-h-[85vh] fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 overflow-hidden flex flex-col"
    >
      <div className="flex justify-between items-center mb-4 flex-shrink-0">
        <h2 className="text-xl font-bold">المنتجات البديلة</h2>
        <button
          onClick={close}
          className="text-gray-500 hover:text-gray-700 text-2xl"
        >
          &times;
        </button>
      </div>
      <div className="flex-1 overflow-y-auto">
        {isLoading ? (
          <div className="flex justify-center py-8">
            <Ripple className="border-dark-blue" />
          </div>
        ) : substituteSkus.length > 0 ? (
          <>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pb-4">
              {currentSkus.map((sku, index) => (
                <ProductCard
                  key={index}
                  sku={{
                    ...sku,
                    imageList: [{ imageUrl: sku.imageUrl }],
                    isValid: !!sku.quantity,
                  }}
                />
              ))}
            </div>
          </>
        ) : (
          <div className="text-center py-8 text-gray-500">
            لا توجد منتجات بديلة
          </div>
        )}
      </div>
      {totalPages > 1 && !isLoading && substituteSkus.length > 0 && (
        <div className="flex justify-between items-center mt-4 pt-4 border-t flex-shrink-0">
          <button
            onClick={goToPreviousPage}
            disabled={currentPage === 0}
            className={`px-4 py-2 rounded-lg font-medium ${
              currentPage === 0
                ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                : "bg-blue-600 text-white hover:bg-blue-700"
            }`}
          >
            السابق
          </button>
          <div className="flex items-center gap-2">
            <span className="text-sm text-gray-600">
              الصفحة {currentPage + 1} من {totalPages}
            </span>
          </div>
          <button
            onClick={goToNextPage}
            disabled={currentPage === totalPages - 1}
            className={`px-4 py-2 rounded-lg font-medium ${
              currentPage === totalPages - 1
                ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                : "bg-blue-600 text-white hover:bg-blue-700"
            }`}
          >
            التالي
          </button>
        </div>
      )}
    </CardsModal>
  );
};

export default AlternativesModal;
